import { css } from '@/styled-system/css';

export const managerName = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const verifiedBadge = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'sm',
  color: 'hpxTeal500',
  marginBottom: '2x',
});

export const verifiedIcon = css({
  width: '16px',
  height: '16px',
});

export const officeHours = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const officeHoursLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const officeHoursLine = css({
  lineHeight: '1.6',
  color: 'hpxBlue500',
});

export const managerIcon = css({
  width: '16px',
  height: '16px',
});

export const footerActions = css({
  display: 'flex',
  gap: '1x',
  width: '100%',
  marginTop: '2x',
});
